import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorPage = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: 'errors/general',
    illustrationProps: {
      width: 200
    },
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmObjectBoardCard.errorPage.generic.title"
    }),
    children: /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-selenium-test": "error-message",
        message: "crmObjectBoardCard.errorPage.generic.body"
      }), ' ', /*#__PURE__*/_jsx(Link, {
        onClick: () => window.location.reload(),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "crmObjectBoardCard.errorPage.links.refresh"
        })
      })]
    })
  });
};